import { render, staticRenderFns } from "./ListarTransferido.vue?vue&type=template&id=4ad091a0&scoped=true&"
import script from "./ListarTransferido.vue?vue&type=script&lang=js&"
export * from "./ListarTransferido.vue?vue&type=script&lang=js&"
import style0 from "./ListarTransferido.vue?vue&type=style&index=0&id=4ad091a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad091a0",
  null
  
)

export default component.exports